export default function AboutSection() {
  return (
    <section id="about" className="w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-100 text-center mb-3">
          关于51暗网
        </h2>
        <p className="text-foreground-500 text-sm text-center mb-10 max-w-lg mx-auto">
          了解我们的使命与价值观
        </p>

        <div className="max-w-3xl mx-auto">
          <div className="bg-background-50 border border-background-200/60 rounded-lg p-6 md:p-8">
            <div className="flex items-center gap-4 mb-6">
              <div className="w-14 h-14 rounded-lg bg-primary-500/10 border border-primary-500/20 flex items-center justify-center shrink-0">
                <span className="font-heading text-xl font-bold text-primary-400">51</span>
              </div>
              <div>
                <h3 className="font-heading text-lg font-semibold text-foreground-100">51暗网 · 中文暗网指南第一站</h3>
                <p className="text-foreground-500 text-xs mt-0.5">成立于2024年，持续更新至今</p>
              </div>
            </div>

            <div className="space-y-4 text-foreground-500 text-sm leading-relaxed">
              <p>
                51暗网是中文互联网领域最全面的暗网知识科普与深度网访问指南平台。我们致力于为广大中文用户提供准确、实用、安全的暗网入门知识，帮助每一位对暗网好奇的探索者安全、合法地了解暗网世界。
              </p>
              <p>
                本站汇聚了暗网基础概念、暗网浏览器（Tor浏览器、I2P等）使用教程、暗网网址导航、深度网资源索引、暗网安全访问全攻略以及最新的吃瓜爆料内容。所有内容均由暗网安全研究领域的资深贡献者编写与审核，确保信息的准确性与时效性。
              </p>
              <p>
                51暗网坚定反对任何形式的网络犯罪活动。我们提供技术知识的目的，是为了提升中文用户的网络安全意识和隐私保护能力。我们始终倡导合法、负责任地使用暗网技术。本站所有内容仅供教育与研究参考，请遵守你所在地区的法律法规。
              </p>
              <p>
                我们同时开放匿名投稿通道，欢迎暗网爱好者与安全研究人员分享你的见闻与见解。你的每一次投稿，都在帮助更多人安全地探索互联网的深层世界。
              </p>
            </div>

            <div className="mt-6 pt-6 border-t border-background-200/60 flex flex-col sm:flex-row gap-4">
              <a
                href="#contact"
                className="flex-1 py-2.5 bg-primary-500 hover:bg-primary-600 text-background-950 font-medium text-sm rounded-md transition-all duration-200 text-center whitespace-nowrap"
              >
                匿名投稿通道
              </a>
              <a
                href="#faq"
                className="flex-1 py-2.5 bg-background-100 hover:bg-background-200 border border-background-300 text-foreground-300 hover:text-foreground-100 font-medium text-sm rounded-md transition-all duration-200 text-center whitespace-nowrap"
              >
                查看常见问答
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}